/* OOMAME article layer v2.1, 12.10.2026, maestro. Design only: wraps, folds and decorates. The article text and links stay in the page. */
(function(){
  var c=document.querySelector('.article__content');if(!c)return;c.classList.add('oa');
  function wrap(h2,cls){var sec=document.createElement('section');sec.className='oa-sec '+cls;h2.parentNode.insertBefore(sec,h2);var n=h2,list=[];while(n){list.push(n);n=n.nextElementSibling;if(n&&n.tagName==='H2')break;}list.forEach(function(x){sec.appendChild(x)});return sec;}
  var h2s=[].slice.call(c.children).filter(function(e){return e.tagName==='H2'});
  h2s.forEach(function(h){
    var t=h.textContent.trim();
    if(/^מתכון/.test(t))wrap(h,'oa-recipe');
    else if(/(ההבדל|איפה קונים|מה לקנות|על המדף|מה לקחת|סל המתכון|מוכן מול)/.test(t))wrap(h,'oa-shop');
    else if(/שאלות/.test(t)){var f=wrap(h,'oa-faq-sec');faq(f);}
    else if(/^למה זה עובד/.test(t))wrap(h,'oa-close');
  });
  var ps=c.querySelectorAll('p');var last=ps[ps.length-1];if(last&&last.querySelector('em')&&/אומאמי/.test(last.textContent))last.classList.add('oa-sign');
  cards(c);
  toc();

  /* FAQ: every <p><strong>question?</strong> answer</p> becomes an open/close row */
  function faq(sec){
    [].slice.call(sec.children).forEach(function(p){
      if(p.tagName!=='P')return;var s=p.firstElementChild;if(!s||s.tagName!=='STRONG')return;
      var q=s.textContent.trim();if(!/\?$/.test(q)||p.textContent.trim().indexOf(q)!==0)return;
      var d=document.createElement('details');d.className='oa-qa';
      var sm=document.createElement('summary');sm.textContent=q;s.remove();
      var n=p.firstChild;while(n&&((n.nodeType===3&&!n.textContent.trim())||n.nodeName==='BR')){var nx=n.nextSibling;p.removeChild(n);n=nx;}
      var a=document.createElement('div');a.className='oa-qa__a';var np=document.createElement('p');while(p.firstChild)np.appendChild(p.firstChild);a.appendChild(np);
      d.appendChild(sm);d.appendChild(a);p.parentNode.replaceChild(d,p);
    });
  }

  /* Product cards: a list row that links to a product gets image, live price, kosher tag and add to cart. The row text stays as written. */
  function cards(sec){
    [].slice.call(sec.querySelectorAll('ul > li')).forEach(function(li){
      if(li.closest('.oa-tldr,.oa-toc,.oa-pass'))return;
      var a=null,lt=li.textContent.replace(/\s+/g,' ').trim();
      [].slice.call(li.querySelectorAll('a[href*="/products/"]')).some(function(x){var at=x.textContent.replace(/\s+/g,' ').trim();var i=lt.indexOf(at);if((i>-1&&i<=40)||at.length<=12){a=x;return true}return false});
      if(!a)return;
      var m=a.getAttribute('href').match(/\/products\/([^?#\/]+)/);if(!m)return;
      fetch('/products/'+m[1]+'?view=oacard',{credentials:'same-origin'}).then(function(r){return r.ok?r.text():null}).then(function(txt){
        if(!txt)return;var p;try{p=JSON.parse(txt)}catch(e){return}
        if(!p||!p.v)return;
        var body=document.createElement('div');body.className='oa-pcard__body';while(li.firstChild)body.appendChild(li.firstChild);
        var pic=document.createElement('a');pic.className='oa-pcard__img';pic.href='/products/'+p.h;pic.setAttribute('aria-hidden','true');pic.tabIndex=-1;
        if(p.img){var im=document.createElement('img');im.src=p.img;im.alt='';im.width=180;im.height=180;im.loading='lazy';pic.appendChild(im);}
        var bar=document.createElement('div');bar.className='oa-pcard__bar';
        var pr=document.createElement('span');pr.className='oa-pcard__price';pr.textContent='₪'+p.p;bar.appendChild(pr);
        if(p.k&&!/ללא/.test(p.k)){var k=document.createElement('span');k.className='oa-pcard__k';k.textContent='כשר';k.title=p.k;bar.appendChild(k);}
        var b=document.createElement('button');b.type='button';b.className='oa-pcard__btn';
        if(p.a){b.textContent='הוספה לסל';b.addEventListener('click',function(){add(p.v,b)});}else{b.textContent='אזל זמנית';b.disabled=true;}
        bar.appendChild(b);
        li.classList.add('oa-pcard');li.appendChild(pic);li.appendChild(body);body.appendChild(bar);
      }).catch(function(){});
    });
  }
  function add(id,b){
    b.disabled=true;b.textContent='מוסיף...';
    fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:id,quantity:1}],sections:'cart-icon-bubble'})})
    .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
    .then(function(x){
      if(!x.ok){b.textContent='לא נוסף, נסו שוב';b.disabled=false;return;}
      b.textContent='נוסף לסל ✓';b.classList.add('is-added');
      track(id);
      try{var html=x.j.sections&&x.j.sections['cart-icon-bubble'];var el=document.getElementById('cart-icon-bubble');if(html&&el){var t=new DOMParser().parseFromString(html,'text/html').querySelector('.shopify-section');if(t)el.innerHTML=t.innerHTML;}}catch(e){}
      setTimeout(function(){b.textContent='הוספה לסל';b.disabled=false;b.classList.remove('is-added')},2500);
    }).catch(function(){b.textContent='לא נוסף, נסו שוב';b.disabled=false;});
  }

  /* Measurement: which article sent the add to cart. Order attribute (seen in admin per order), GA4 event, Shopify custom event. */
  function track(id){
    var art='';try{art=decodeURIComponent(location.pathname.split('/').pop())}catch(e){}
    try{fetch('/cart/update.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes:{blog_card_add:art}})});}catch(e){}
    try{if(typeof window.gtag==='function')window.gtag('event','blog_card_add_to_cart',{article:art,variant_id:String(id)});}catch(e){}
    try{if(window.Shopify&&Shopify.analytics&&Shopify.analytics.publish)Shopify.analytics.publish('blog_card_add_to_cart',{article:art,variant_id:id});}catch(e){}
  }

  /* Table of contents for long articles (6 sections or more) */
  function toc(){
    var hs=[].slice.call(c.querySelectorAll('h2'));if(hs.length<6)return;
    var nav=document.createElement('nav');nav.className='oa-toc';nav.setAttribute('aria-label','תוכן הכתבה');
    var d=document.createElement('details');var sm=document.createElement('summary');sm.textContent='מה בכתבה';d.appendChild(sm);
    var ol=document.createElement('ol');
    hs.forEach(function(h,i){if(!h.id)h.id='oa-h'+(i+1);var li=document.createElement('li');var a=document.createElement('a');a.href='#'+h.id;a.textContent=h.textContent.trim();li.appendChild(a);ol.appendChild(li);});
    d.appendChild(ol);nav.appendChild(d);
    var after=c.querySelector(':scope > .oa-tldr')||c.querySelector(':scope > .oa-pass');
    if(after)after.parentNode.insertBefore(nav,after.nextSibling);else{var fp=c.querySelector(':scope > p');if(fp)fp.parentNode.insertBefore(nav,fp.nextSibling);}
  }
})();
